import { UnidadAcademica } from './unidadacademica';

export class Investigador {
  ID_Experto: number ;
  Desarrollo: string;
  Visible: boolean;
  Nombre: string;
  Apellido: string;
  Palabras_clave: string;
  Slug: string;
  Foto: string;
  Cuil: string;
  UnidadAcademica: UnidadAcademica;
  Tipo: number;
  EMail: string;
  AparicionMedios: string;
  informacion_idiomas = [];
}


// WEBPACK FOOTER //
// ./src/app/shared/dominio/investigador.ts